

import {Link} from 'react-router-dom'

import { reduxForm , handleSubmit, FieldArray,Field, startSubmit, formValueSelector} from 'redux-form'
import {SVLAFORM,SV_SERVICES, SV_SERVER_ADDRESS, SV_URL} from '../../../constants'
import { Icon, Button as SVAButton, Row, Col, Badge } from 'antd';
const React = require('react')

const {connect}  = require("react-redux")

const _ = require('lodash')
//const {Link} = require("react-router")


const svsubmit =(values)=>{
    let me = this
  console.log('sv submit callback')
  console.log(values)

}


const renderField = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  const renderFieldDup = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          {touched && error &&  <input className="sverr form-control" {...input} type={type} placeholder={label} /> }
          {touched && !error &&  <input className="svgreen form-control" {...input} type={type} placeholder={label} /> }
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  /*
const renderSelectList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )
  const renderTravelSelectList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )

  const renderBookingAgentType = ({input, data})=> (
      <SelectList {...input } onBlur={() =>input.onBlur()} data={data} />
  )
*/
let dcountries = [{
    name:'United States Of America',
    value:'usa'

  },{
    name:'France',
    value:'France'
  },{

    name:'China',
    value:'China'
},{
    name:'Mexico',
    value:'Mexico'
  
  }]

let genes = [{
    name:'add_step',
    value:'add_step'

  },{
    name:'multiply_seq_step',
    value:'multiply_seq_step'
  },{

    name:'sq_step',
    value:'sq_step'
},{
    name:'sr_step',
    value:'sr_step'
  
  }]


let svChange = (values, dispatch, props, valuesPrev)=>{

    console.log('sv LA form  value changed')
  
    console.log(values)
  
  
  }


let validate =(formData)=>{
    console.log('sv--valudare fprmData')
      console.log(validate)
        const errors={}
        if(!formData){
            console.log('validate: sv formData null issue')
            return errors
        }
       
        if(!formData.username){
            errors.username= 'Required'
        }
        if(!formData.password){
            errors.password= 'Required'
        }
       
       
        return errors
    
    }
    
    let warn= (formData)=>{
        const o = {}
        if(!formData){
            console.log('sv gene null issue')
            return o
        }
        /*
        if(formData.lname <2){
            o.gene ='We expect gene to br more tham 5'
        }
        */
        return o
    }


class CreateLoginabodeFormBus extends React.Component{

    constructor(props){
        
        super(props)
        let me = this
        this.loadGene = this.loadGene.bind(this)
       
        this.cancelPage = this.cancelPage.bind(this) 
       
       
        this.getAppDetails = this.getAppDetails.bind(me)
       
    }
    
   

    getAppDetails(paramQSpaceId){
        //fWe do not need this we are cerate login there is no edit here Profile and Login are 2 different moduls.

        let id = -1
        if(paramQSpaceId ){
            id  = parseInt(paramQSpaceId)
        }
        console.log("id* addressr det or cerate ******", id)
      
       
    }
    cancelPage(){
        console.log('cancel page')

    }
 loadGene(e){
        console.log(e)
    }


    
    
    render(){
        console.log('sv... CreateLoginabodeFormBusCom 178898  =7899m2912345')
        const { handleSubmit, pristine, error,reset, submitting } = this.props
        //const { initialValues,load, handleSubmit,loadGeneTemplate,  pristine, reset, submitting, submit, startSubmit } = this.props 
       // const { id, gene} = initialValues
        const me = this 
        //me.gene = gene
        let initialValues = this.props.initialValues

        console.log(this.props)

        const {det} = this.props
        
        if(det ){
            initialValues = det
        }


        return (
            <div className="svr-det-pageWrapper">
            <header className="svr-header1">
                <h1><span><text style={{color:'#f0d8a9'}}>LOGIN  </text></span> </h1>
            </header>
            <div>
                    <form  onSubmit={handleSubmit}>
                            <div className="rev-row">
                                <div className="card card--raised with-shadow">
                                    <p className="right-sd-content"> <text> Returning Customer </text></p>
                                    {/* 
                                        <div className="form-group">
                                          
                                            <label htmlFor="id"> ID</label>
                                            
                                                <Field
                                            
                                                id="id"
                                                    name="id"
                                                    type="text"
                                                    placeholder="id"
                                                    component="input"
                                                    className="form-control"
                                                />
                                            

                                        </div>
                                        */}
                                        <div className="form-group">
                                            <label htmlFor="fname"> Userid(Email)</label>
                                            
                                                <Field
                                            
                                                    id="username"
                                                    name="username"
                                                    type="text"
                                                    placeholder="pet123@yahoo.com"
                                                    component={renderField}
                                                    className="form-control"
                                                />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="lname"> Password</label>
                                            <Field
                                                    id="password"
                                                    name="password"
                                                    type="password"
                                                    placeholder="pet123"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                       
                                    </div>
                            </div>

                            <div>
               {/*  
        <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svessearch`}> Home Page   </Link></SVAButton>
        */}
               <button type="submit" className="btn btn-success" disabled={pristine || error || submitting}>
         LOGIN
        </button>  
         
        <SVAButton onClick={()=>this.props.svuserLogoutparent()} style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >SV Logout</SVAButton>
        
        <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svregus/svreguser/-1`}> Create Account/Profile   </Link></SVAButton>
        <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svregus/svepwr`}> Forgot Password   </Link></SVAButton>
        <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svhome`}> Cancel   </Link></SVAButton>
        
        <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><a href="http://localhost:8087/login"> 87Login   </a></SVAButton>
        
        
         </div>
                    </form>
            </div>
        </div>
        )
                    
                    

    }
}



const selector = formValueSelector(SVLAFORM)
/*
let svChange = (values, dispatch, props, valuesPrev)=>{

    console.log('sv form change')
  
    console.log(values)
  
  
  }
  */

const laForm  = reduxForm({
    form:SVLAFORM,
    validate:validate,
   
    warn:warn,
    //onSubmit:svsubmit,
    onChange:svChange,
    enableReinitialize:true,
    keepDirtyOnReinitialize:true

})(CreateLoginabodeFormBus)
/*
let CreateLoginabodeFormFormBusCom =connect((state=>{
    const { svstoredcarddetView, svusercreddetView} = state
    let plucked = state.movies  
    //let o = {initialValues:plucked.adData }
    let o = {initialValues:svstoredcarddetView.my_data_addressdet}
    //let o = {initialValues:svusercreddetView.my_data_addressdet,my_data_profile:my_data_profile }
    console.log('sv*******************CrateAddressForm shoul getmy_data_addressdet start ')
    
    //selector(state, 'id')
    console.log('sv info')
    console.log(o)
    console.log('sv*******************CrateAddressForm shoul getmy_data_addressdet end ')
    
    return o
   // return plucked.adData
}),{
    //load:loadAdAction,
   
    startSubmit:startSubmit
   
   // loadGeneTemplate:loadGeneTemplate

    
} ,null,{ forwardRef: true})(laForm)

*/
let CreateLoginabodeFormFormBusCom =connect((state=>{
    const { svstoredcarddetView, svusercreddetView} = state
    let plucked = state.movies  
    //let o = {initialValues:plucked.adData }
    let o = {initialValues:svstoredcarddetView.my_data_addressdet}
    //let o = {initialValues:svusercreddetView.my_data_addressdet,my_data_profile:my_data_profile }
    console.log('sv*******************CrateAddressForm shoul getmy_data_addressdet start ')
    
    //selector(state, 'id')
    console.log('sv info')
    console.log(o)
    console.log('sv*******************CrateAddressForm shoul getmy_data_addressdet end ')
    
    return o
   // return plucked.adData
}),{
    //load:loadAdAction,
   
    startSubmit:startSubmit
   
   // loadGeneTemplate:loadGeneTemplate

    
})(laForm)


export default CreateLoginabodeFormFormBusCom
//const CreateLoginabodeFormBusCom  =x